import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import { Shield, Mail } from 'lucide-react';

export const SecuritySection = ({
  securityEmailsEnabled,
  setSecurityEmailsEnabled
}) => {
  return (
    <Card data-testid="security-settings-card">
      <CardHeader>
        <CardTitle className="text-xl font-semibold font-title flex items-center gap-2">
          <Shield className="w-5 h-5 text-emerald-600" strokeWidth={1.5} />
          Security Settings
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between p-4 rounded-xl bg-gray-50 border border-gray-200">
          <div className="flex items-start gap-3">
            <div className="p-2 bg-emerald-100 rounded-lg text-emerald-600">
              <Mail className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <div>
              <Label htmlFor="security-emails" className="text-base font-medium text-gray-900 cursor-pointer">
                New device login alerts
              </Label>
              <p className="text-sm text-gray-500 mt-1">
                Receive an email notification when someone logs into your account from a new device
              </p>
            </div>
          </div>
          <Switch
            id="security-emails"
            checked={securityEmailsEnabled}
            onCheckedChange={setSecurityEmailsEnabled}
            className="data-[state=checked]:bg-emerald-600"
            data-testid="security-emails-toggle"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default SecuritySection;
